@file:OptIn(ExperimentalWasmJsInterop::class)

package one.healthium.logger

import co.touchlab.kermit.Severity

fun enableSentry(environment: String) {
    initJs { options ->
        options.dsn = "https://9cefcb3da8191380cb68e6de53868424@o4505505369620480.ingest.us.sentry.io/4510698920738816"
        options.debug = false
        options.sendDefaultPii = true
        options.environment = environment
        options.attachStackTrace = true
        options.tracesSampleRate = 1.0
    }
}

private fun throwableToJsError(throwable: Throwable): JsAny {
    val error: dynamic = js("new Error()")
    error.name = throwable::class.simpleName ?: "KotlinThrowable"
    error.message = throwable.message ?: "Unknown error"
    error.stack = throwable.stackTraceToString()

    throwable.cause?.let {
        error.cause = throwableToJsError(it)
    }

    return error.unsafeCast<JsAny>()
}

class SentryLogWriter : co.touchlab.kermit.LogWriter() {
    override fun log(
        severity: Severity,
        message: String,
        tag: String,
        throwable: Throwable?
    ) {
        if (severity >= Severity.Error) {
            if (throwable != null) {
                SentryJs.captureMessage("$tag: $message")
                SentryJs.captureException(throwableToJsError(throwable))
            } else {
                SentryJs.captureMessage("$tag: $message")
            }
        }
    }
}